import { useSWRFetch } from '@/services/common'
import { useNoticeError } from './useNoticeError'
import { Dispatch, SetStateAction } from 'react'
import { NotificationType } from '@/types/common/notification'

/**
 * ユーザ(参加者)情報取得Hooks
 * @returns
 */
export const useUser = ({
  setNotification,
}: {
  setNotification: Dispatch<SetStateAction<NotificationType>>
}) => {
  const { result, error, isLoading } = useSWRFetch({
    method: 'get',
    url: process.env.NEXT_PUBLIC_API_USER_LIST,
  })

  useNoticeError({
    error,
    setNotification,
  })

  return { result, isLoading }
}
